export const hubLocations = [
  {
    Name: "FFH  Karshi",
    State: "FCT, Abuja",
    LGA: "AMAC",
    "Town ": "Karshi",
    "Store Address": "Karshi",
    Latitude: 9.03716667,
    Longitude: 7.82180556,
  },
  {
    Name: "FFH  Bauchi",
    State: "Bauchi State",
    LGA: "Bauchi",
    "Town ": "Bauchi",
    "Store Address": "Bauchi",
    Latitude: 10.296202,
    Longitude: 9.805598,
  },
  {
    Name: "FFH  Azare",
    State: "Bauchi State",
    LGA: "Katagum",
    "Town ": "Azare",
    "Store Address": "Azare",
    Latitude: 11.3957,
    Longitude: 10.125,
  },
  {
    Name: "FFH  Katagum",
    State: "Bauchi State",
    LGA: "Zaki",
    "Town ": "Katagum",
    "Store Address": "Katagum",
    Latitude: 12.48386111,
    Longitude: 10.56886111,
  },
  {
    Name: "FFH  Dass",
    State: "Bauchi State",
    LGA: "Dass",
    "Town ": "Dass",
    "Store Address": "Dass",
    Latitude: 10.04741667,
    Longitude: 9.86022222,
  },
  {
    Name: "FFH  Soro",
    State: "Bauchi State",
    LGA: "Ganjuwa",
    "Town ": "Soro",
    "Store Address": "Soro",
    Latitude: 10.77333333,
    Longitude: 10.29083333,
  },
  {
    Name: "FFH  Wannune",
    State: "Benue State",
    LGA: "Tarka",
    "Town ": "Wannune",
    "Store Address": "Wannune",
    Latitude: 7.937,
    Longitude: 8.76883333,
  },
  {
    Name: "FFH Vandeikya",
    State: "Benue State",
    LGA: "Vandeikya",
    "Town ": "Vandeikya",
    "Store Address": "Vandeikya",
    Latitude: 6.93883333,
    Longitude: 9.15283333,
  },
  {
    Name: "FFH  Kaltungo",
    State: "Gombe State",
    LGA: "Kaltungo",
    "Town ": "Kaltungo",
    "Store Address": "Kaltungo",
    Latitude: 9.69361111,
    Longitude: 11.475,
  },
  {
    Name: "FFH  Kumo",
    State: "Gombe State",
    LGA: "Akko",
    "Town ": "Kumo",
    "Store Address": "Kumo",
    Latitude: 10.04541667,
    Longitude: 11.3475,
  },
  {
    Name: "FFH  Dukku",
    State: "Gombe State",
    LGA: "Dukku",
    "Town ": "Dukku",
    "Store Address": "Dukku",
  },
  {
    Name: "FFH Billiri",
    State: "Gombe State",
    LGA: "Billiri",
    "Town ": "Billiri",
    "Store Address": "Billiri",
    Latitude: 9.886941,
    Longitude: 11.219386,
  },
  {
    Name: "FFH  Talasse",
    State: "Gombe State",
    LGA: "Balanga",
    "Town ": "Talasse",
    "Store Address": "Talasse",
  },
  {
    Name: "FFH  Laraba",
    State: "Jigawa State",
    LGA: "Dutse",
    "Town ": "Laraba",
    "Store Address": "Laraba",
  },
  {
    Name: "FFH  Kwoi",
    State: "Kaduna State",
    LGA: "Jaba",
    "Town ": "Kwoi",
    "Store Address": "Kwoi",
    Latitude: 9.44683333,
    Longitude: 8.00966667,
  },
  {
    Name: "FFH  Gidan waya",
    State: "Kaduna State",
    LGA: "Jema'a",
    "Town ": "Gidan waya",
    "Store Address": "G/Waya",
    Latitude: 9.78105556,
    Longitude: 8.65175,
  },
  {
    Name: "FFH  Kauru",
    State: "Kaduna State",
    LGA: "Kauru",
    "Town ": "Kauru",
    "Store Address": "Kauru",
    Latitude: 10.96375,
    Longitude: 8.25919444,
  },
  {
    Name: "FFH  Dawanau",
    State: "Kano State",
    LGA: "Bichi",
    "Town ": "Dawanau",
    "Store Address": "Dawanau",
  },
  {
    Name: "FFH  Mijinbir",
    State: "Kano State",
    LGA: "Minjibir",
    "Town ": "Minjibir",
    "Store Address": "Minjibir",
  },
  {
    Name: "FFH  Dawakin Kudu",
    State: "Kano State",
    LGA: "Dawakin Kudu",
    "Town ": "Dawakin Kudu",
    "Store Address": "Dawakin Kudu",
  },
  {
    Name: "FFH  Kamba",
    State: "Kebbi State",
    LGA: "Dandi",
    "Town ": "Kamba",
    "Store Address": "Kamba",
    Latitude: 11.86072222,
    Longitude: 3.65977778,
  },
  {
    Name: "FFH  Zauro",
    State: "Kebbi State",
    LGA: "Birnin Kebbi",
    "Town ": "Zauro",
    "Store Address": "Zauro",
    Latitude: 12.49563889,
    Longitude: 4.30694444,
  },
  {
    Name: "FFH  Augie",
    State: "Kebbi State",
    LGA: "Augie",
    "Town ": "Augie",
    "Store Address": "Augie",
    Latitude: 12.81888889,
    Longitude: 4.98530556,
  },
  {
    Name: "FFH Idah",
    State: "Kogi State",
    LGA: "Idah",
    "Town ": "Idah",
    "Store Address": "Idah",
    Latitude: 7.16263889,
    Longitude: 6.11825,
  },
  {
    Name: "FFH  Lafiagi",
    State: "Kwara State",
    LGA: "Lafiagi",
    "Town ": "Lafiagi",
    "Store Address": "Lafiagi",
  },
  {
    Name: "FFH  Shonga",
    State: "Kwara State",
    LGA: "Shonga",
    "Town ": "Shonga",
    "Store Address": "Shonga",
  },
  {
    Name: "FFH  Tsaragi",
    State: "Kwara State",
    LGA: "Edu",
    "Town ": "Tsaragi",
    "Store Address": "Tsaragi",
  },
  {
    Name: "FFH  Ashangwa",
    State: "Nasarawa State",
    LGA: "Lafia",
    "Town ": "Ashangwa",
    "Store Address": "Ashangwa",
  },
  {
    Name: "FFH Gitata",
    State: "Nasarawa State",
    LGA: "Karu",
    "Town ": "Gitata",
    "Store Address": "Gitata",
    Latitude: 9.12538,
    Longitude: 7.94242,
  },
  {
    Name: "FFH Agyaragu",
    State: "Nasarawa State",
    LGA: "Lafia",
    "Town ": "Agyaragu",
    "Store Address": "Agyaragu",
    Latitude: 8.39581,
    Longitude: 8.54556,
  },
  {
    Name: "FFH Nasarawa Toto",
    State: "Nasarawa State",
    LGA: "Nasarawa Toto",
    "Town ": "Nasarawa Toto",
    "Store Address": "Nasarawa Toto",
  },
  {
    Name: "FFH Ibbi",
    State: "Niger State",
    LGA: "Ibbi",
    "Town ": "Ibbi",
    "Store Address": "Ibbi",
    Latitude: 9.962,
    Longitude: 4.90169444,
  },
  {
    Name: "FFH Enagi",
    State: "Niger State",
    LGA: "Enagi",
    "Town ": "Enagi",
    "Store Address": "Enagi",
    Latitude: 9.21822222,
    Longitude: 5.90011111,
  },
  {
    Name: "FFH  Donbitso",
    State: "Niger State",
    LGA: "Gurara",
    "Town ": "Lambata",
    "Store Address": "Donbitso",
    Latitude: 9.28244444,
    Longitude: 6.99491667,
  },
  {
    Name: "FFH  Zungeru",
    State: "Niger State",
    LGA: "Wushishi",
    "Town ": "Zungeru",
    "Store Address": "Zungeru",
    Latitude: 9.8025,
    Longitude: 6.15138889,
  },
  {
    Name: "FFH  Agaie",
    State: "Niger State",
    LGA: "Agaie",
    "Town ": "Agaie",
    "Store Address": "Agaie",
    Latitude: 9.02463889,
    Longitude: 6.53236111,
  },
  {
    Name: "FFH  Owode",
    State: "Ogun State",
    LGA: "Owode",
    "Town ": "Owode",
    "Store Address": "Owode",
  },
  {
    Name: "FFH  Owode Egba",
    State: "Ogun State",
    LGA: "Owode Egba",
    "Town ": "Owode Egba",
    "Store Address": "Owode Egba",
  },
  {
    Name: "FFH  Owo",
    State: "Ondo State",
    LGA: "Owo",
    "Town ": "Owo",
    "Store Address": "Owo",
  },
  {
    Name: "FFH  Ikoyi",
    State: "Osun State",
    LGA: "Ikoyi",
    "Town ": "Ikoyi",
    "Store Address": "Ikoyi ",
  },
  {
    Name: "FFH  Saki",
    State: "Oyo State",
    LGA: "Saki",
    "Town ": "Saki",
    "Store Address": "Saki",
  },
  {
    Name: "FFH  Iseyin",
    State: "Oyo State",
    LGA: "Iseyin",
    "Town ": "Iseyin",
    "Store Address": "Iseyin",
  },
  {
    Name: "FFH  Lalante",
    State: "Oyo State",
    LGA: "Lalante",
    "Town ": "Lalante",
    "Store Address": "Lalante",
  },
  {
    Name: "FFH  Ayetoro",
    State: "Oyo State",
    LGA: "Ayetoro",
    "Town ": "Ayetoro",
    "Store Address": "Ayetoro",
  },
  {
    Name: "FFH  Kopal",
    State: "Plateau State",
    LGA: "Mangu",
    "Town ": "Kopal",
    "Store Address": "Kopal",
    Latitude: 9.3522,
    Longitude: 9.21109,
  },
  {
    Name: "FFH  Rukuba",
    State: "Plateau State",
    LGA: "Bassa",
    "Town ": "Rukuba",
    "Store Address": "Rukuba",
    Latitude: 9.5559,
    Longitude: 8.4359,
  },
  {
    Name: "FFH  Namu",
    State: "Plateau State",
    LGA: "Quanpa",
    "Town ": "Namu",
    "Store Address": "Namu",
    Latitude: 8.68498,
    Longitude: 9.08549,
  },
  {
    Name: "FFH  Wase",
    State: "Plateau State",
    LGA: "Wase",
    "Town ": "Wase",
    "Store Address": "Wase",
  },
  {
    Name: "FFH  Rizek",
    State: "Plateau State",
    LGA: "Jos East",
    "Town ": "Jos",
    "Store Address": "Rizek",
    Latitude: 9.89454,
    Longitude: 8.96576,
  },
  {
    Name: "FFH  Kware",
    State: "Sokoto State",
    LGA: "Kware",
    "Town ": "Kware",
    "Store Address": "Kware",
    Latitude: 13.516,
    Longitude: 5.1619,
  },
  {
    Name: "FFH  Tambuwal",
    State: "Sokoto State",
    LGA: "Tambuwal",
    "Town ": "Tambuwal",
    "Store Address": "Tambuwal",
    Latitude: 12.40365,
    Longitude: 4.63801,
  },
  {
    Name: "FFH  Illela",
    State: "Sokoto State",
    LGA: "Illela",
    "Town ": "Illela",
    "Store Address": "Illela",
    Latitude: 13.71898,
    Longitude: 5.29394,
  },
  {
    Name: "FFH  Wurno",
    State: "Sokoto State",
    LGA: "Wurno",
    "Town ": "Wurno",
    "Store Address": "Wurno",
    Latitude: 13.17831,
    Longitude: 5.25154,
  },
  {
    Name: "FFH  Goronyo",
    State: "Sokoto State",
    LGA: "Goronyo",
    "Town ": "Goronyo",
    "Store Address": "Goronyo",
  },
  {
    Name: "FFH  Nguroje",
    State: "Taraba State",
    LGA: "Sardauna",
    "Town ": "Nguroje",
    "Store Address": "Nguroje",
  },
  {
    Name: "FFH  Mayo Lope",
    State: "Taraba State",
    LGA: "Lau",
    "Town ": "Mayo Lope",
    "Store Address": "Mayo Lope",
    Latitude: 9.14366,
    Longitude: 11.40503,
  },
  {
    Name: "FFH  Bali",
    State: "Taraba State",
    LGA: "Bali",
    "Town ": "Bali",
    "Store Address": "Bali",
    Latitude: 7.872124,
    Longitude: 10.972613,
  },
  {
    Name: "FFH  Zing",
    State: "Taraba State",
    LGA: "Zing",
    "Town ": "Zing",
    "Store Address": "Zing",
    Latitude: 8.989621,
    Longitude: 11.762294,
  },
  {
    Name: "FFH  Tella",
    State: "Taraba State",
    LGA: "Gassol",
    "Town ": "Tella",
    "Store Address": "Tella",
  },
  {
    Name: "FFH  Gusau",
    State: "Zamfara State",
    LGA: "Gusau",
    "Town ": "Gusau",
    "Store Address": "Gusau",
    Latitude: 12.923916,
    Longitude: 6.4266,
  },
  {
    Name: "FFH  Maradun",
    State: "Zamfara State",
    LGA: "Maradun",
    "Town ": "Maradun",
    "Store Address": "Maradun",
    Latitude: 12.5546,
    Longitude: 6.17517,
  },
  {
    Name: "FFH  Anka",
    State: "Zamfara State",
    LGA: "Anka",
    "Town ": "Anka",
    "Store Address": "Anka",
    Latitude: 12.064,
    Longitude: 5.5585,
  },
  {
    Name: "FFH  Kauran Nomoda",
    State: "Zamfara State",
    LGA: "Kauran Namoda",
    "Town ": "Kauran Namoda",
    "Store Address": "Kauran Namoda",
    Latitude: 12.3377,
    Longitude: 6.33948,
  },
  {
    Name: "FFH  Gumi",
    State: "Zamfara State",
    LGA: "Gumi",
    "Town ": "Gumi",
    "Store Address": "Gummi",
    Latitude: 12.13035,
    Longitude: 5.1305,
  },
  {
    Name: "FFH  Maru",
    State: "Zamfara State",
    LGA: "Maru",
    "Town ": "Maru",
    "Store Address": "Maru",
    Latitude: 12.19843,
    Longitude: 6.23763,
  },
];
